$ = jQuery;

function gallery_swiper_init(){

  const swiper = new Swiper('.gallery-slider .swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      centeredSlides: false,
      slidesPerView: 4,
      spaceBetween: 28,
      updateOnWindowResize: true,
      // autoplay: {
      //     delay: 4000,
      // },
      
      navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
      },
      
      breakpoints: {
        1: {
            slidesPerView: 1,
            spaceBetween: 28,
        },
        480: {
            slidesPerView: 2,
            spaceBetween: 28,
        },
        576: {
            slidesPerView: 3,
            spaceBetween: 28,
        },
        1023: {
            slidesPerView: 4,
            spaceBetween: 28,
        }
      }
      
  });
}

gallery_swiper_init();